module.exports = __webpack_public_path__ + "img/support-user.6d90651c.png";